<template>
	<div>
        <div class="row">
            <el-form  class="mt-0" label-position="top" label-width="100px">
                <div class="row">
                    <div class="col-md-2">	
                        <el-form-item label="Bulan:">
                            <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-md-2">	
                        <el-form-item label="Tahun:" style="min-width:85px;">
                            <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-md-2">	
                        <el-form-item label=" ">
                            <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                        </el-form-item>
                    </div>
                    <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                        <el-form-item label=" ">
                            {{ this.lastUpdate }}
                        </el-form-item>
                    </div>
                </div>
            </el-form>

            <div class="row mt-1 pb-3 pr-0">
                <div :class="(String(this.description || '').trim().length > minLengthDescription ? 'col-md-9 pr-4' : 'col-md-12' ) + ' '">
                    <div class="row">
                        <div class="col-md-12 pr-0" style="overflow-x: auto;">
                            <table class="app-table">
                                <tr>
                                    <th rowspan="3">Laporan Laba/Rugi</th>
                                    <!--<th>Real {{ this.year - 1}}</th>-->
                                    <th colspan="2">Target {{this.year}}</th>
                                    <th>Real {{this.year}}</th>
                                    <th>% Achievement</th>
                                    <!--<th>Growth YoY</th>-->
                                </tr>
                                <tr>
                                    <!--<th>Ytd {{ this.options.months.find(d=> d.value==this.month).name }}</th>-->
                                    <th>RKAP</th>
                                    <th>Ytd {{ this.options.months.find(d=> d.value==this.month).name }}</th>
                                    <th>Ytd {{ this.options.months.find(d=> d.value==this.month).name }}</th>
                                    <th>RKAP Ytd</th>
                                    <!--<th>Ytd {{ this.options.months.find(d=> d.value==this.month).name }}</th>-->
                                </tr>
                                <tr>
                                    <!--<th>a</th>-->
                                    <th>a</th>
                                    <th>b</th>
                                    <th>c</th>
                                    <th>d=c/b</th>
                                    <!--<th>f=(d-a)/a</th>-->
                                </tr>

                                <tr v-for="item in reportData.data" :key="item.CategoryCode"
                                :class="(item.CategoryCode == '1' || item.CategoryCode == ('6') || item.CategoryCode == ('11') || item.CategoryCode == ('12') || item.CategoryCode == ('13') || item.CategoryCode == ('14') || item.CategoryCode == ('15')) ? 'text-bold' : '' ">
                                    <td class="text-left" style="min-width:250px;">{{ item.CategoryName }}</td>
                                    <!--<td class="text-right">{{ formatNum(item.RealizationYtdBefore) }}</td>-->
                                    <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                    <td class="text-right">{{ formatNum(item.RKAPYtd) }}</td>
                                    <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                    <td class="text-right">{{ formatNum(item.RKAPAchievement) }}%</td>
                                    <!--<td class="text-right">{{ formatNum(item.GrowthYoy) }}%</td>-->
                                </tr>
                            </table>

                            <Loader v-show="loading.table"/>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="text-center text-chart-title">Revenue</div>
                                    <BarChart v-loading.body="loading.table" :data="chartdatarevenue" :width="500" :height="220" v-if="showchart"/>
                                </div>
                                <div class="col-md-3">
                                    <div class="text-center text-chart-title">Gross Profit</div>
                                    <BarChart v-loading.body="loading.table" :data="chartdatagrossprofit" :width="500" :height="220" v-if="showchart"/>
                                </div>
                                <div class="col-md-3">
                                    <div class="text-center text-chart-title">Net Profit</div>
                                    <BarChart v-loading.body="loading.table" :data="chartdatanetprofit" :width="500" :height="220" v-if="showchart"/>
                                </div>
                                <div class="col-md-3">
                                    <div class="text-center text-chart-title">EBITDA</div>
                                    <BarChart v-loading.body="loading.table" :data="chartdatebitda" :width="500" :height="220" v-if="showchart"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-3 p-0" style="border:1px solid #2F5597;" v-if="String(this.description || '').trim().length > minLengthDescription">
                    <div class="text-center" style="background:#2F5597;">
                        <h6 style="color:#ffffff;">JUSTIFIKASI KINERJA KEUANGAN</h6>
                    </div>
                    <div class="p-3">
                        <div v-html="description"></div>
                        <!--
                        <div style="color:#1D7BBB;"><b>Realisasi Beban Pokok Penjualan</b></div>
                        <p style="text-align:justify;">Realisasi Beban Pokok Penjualan 112% melebihi target RKAP Ytd Mei 2023, sejalan dengan kenaikan Pendapatan sebesar 110%, pergantian spare part dispenser dan maintenance SPBU Rp. 6,82 M, Sarfas IT/internet Rp. 4,45 M.</p>
                        <div style="color:#1D7BBB;"><b>Laba Bruto</b></div>
                        <p style="text-align:justify;">Realisasi Laba bruto under 17% dari target RKAP Ytd Mei 2023, karena dampak dari penurunan Margin KSO.</p>
                        -->
                        <Loader v-if="loading.description"/>
                    </div>
                </div>
            </div>
                
        </div>
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

import {Rainbow, FuelColor, Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
        BarChart,
        Loader,
	},
    props: ['showchart', 'tabName', 'category'],

	data() {
		return {
            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,

            chartdata: [],
            loading: {
                table: false,
                chart: false,
                description: false,
            },

            description: '',
            reportData: [],

            //category: 'FUEL',
            chartdatarevenue: [],
            chartdatagrossprofit: [],
            chartdatanetprofit: [],
            chartdatebitda: [],

            //sample
            chartdata1:[
                {
                    label: 'YTD Mei',
                    legend: 'RKAP YTD Mei 2023',
                    valuecol: 8551964,
                },
                {
                    label: 'YTD Mei',
                    legend: 'Real YTD Mei 2023',
                    valuecol: 9444039,
                }
            ],
            chartdata2:[
                {
                    label: 'YTD Mei',
                    legend: 'RKAP YTD Mei 2023',
                    valuecol: 540839,
                },
                {
                    label: 'YTD Mei',
                    legend: 'Real YTD Mei 2023',
                    valuecol: 446211,
                }
            ],
            chartdata3:[
                {
                    label: 'YTD Mei',
                    legend: 'RKAP YTD Mei 2023',
                    valuecol: 79958,
                },
                {
                    label: 'YTD Mei',
                    legend: 'Real YTD Mei 2023',
                    valuecol: 24866,
                }
            ],
            chartdata4:[
                {
                    label: 'YTD Mei',
                    legend: 'RKAP YTD Mei 2023',
                    valuecol: 148221,
                },
                {
                    label: 'YTD Mei',
                    legend: 'Real YTD Mei 2023',
                    valuecol: 99290,
                }
            ],

            tableData: [
                {
                    title: 'Revenue',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Beban Pokok Penjualan',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Laba / (Rugi) Bruto',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Beban Usaha',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Laba / (Rugi) Usaha',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Pendapatan / Beban lain',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Beban Pajak Penghasilan',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Laba/ (Rugi) Tahun Berjalan',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'EBITDA',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'EBITDA Margin',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Profit Margin',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
            ],
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        this.setDefaultPeriod()
        this.resumePilihan()
        //this.setChart()
        this.getDescription()
    },
    methods: {
        resumePilihan() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/profit-laba?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&type=FUEL'
            this.urlRequestParams+='&category='+this.category

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportData = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))

                this.chartdatarevenue = this.processBarChart(this.reportData.chart_revenue, "legend", "", "valuecol", false, "label", "", 1, 2, this.colors, false, false, false, false);
                this.chartdatagrossprofit = this.processBarChart(this.reportData.chart_gross_profit, "legend", "", "valuecol", false, "label", "", 1, 2, this.colors, false, false, false, false);
                this.chartdatanetprofit = this.processBarChart(this.reportData.chart_net_profit, "legend", "", "valuecol", false, "label", "", 1, 2, this.colors, false, false, false, false);
                this.chartdatebitda = this.processBarChart(this.reportData.chart_ebitda, "legend", "", "valuecol", false, "label", "", 1, 2, this.colors, false, false, false, false);

                this.lastUpdate = this.reportData.last_update
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

        getDescription() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/performance-description?'
            
            this.urlRequestParams+='year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&category='+this.capitalizeWord(this.category).replace(" ", "");

			this.loading.description = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.description = response.data.data.description;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.description = false;
			})     

        },

        setChart() {
            this.chartdatarevenue = this.processBarChart(this.chartdata1, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatagrossprofit = this.processBarChart(this.chartdata2, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatanetprofit = this.processBarChart(this.chartdata3, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatebitda = this.processBarChart(this.chartdata4, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
        },

        setDefaultPeriod() {
            // Mengecek apakah key sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                //console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                //console.log('period belum ada di localStorage');
            }
        },

        applyFilter() {
            this.resumePilihan()
            this.getDescription()
        },
    },
}
</script>


<style scoped>
.app-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  border-radius:4px;
  width: 100% !important;
  overflow-x: auto; 
}

.app-table td, .app-table th {
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background-color: #e0f3ff/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background-color: rgba(66, 161, 255, 0.26) /*#ddd*/;}

.app-table th {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
  background-color: #409EFF/*#0070C0*/;
  color: white;
}

.sub-header-cell {
    background-color: rgba(66, 161, 255, 0.46) /* #8EA9DB*/;
    font-weight:bold;
    color:#000;
}

.red-border {
    border-left:3px solid #F56C6C !important;
    border-right:3px solid #F56C6C !important;
}

.yellow-border {
    border-left:3px solid #E6A23C !important;
    border-right:3px solid #E6A23C !important;
}

.top-red-border {
    border-top:3px solid #F56C6C !important;
}
.bottom-red-border {
    border-bottom:3px solid #F56C6C !important;
}

.top-yellow-border {
    border-top:3px solid #E6A23C !important;
}

.bottom-yellow-border {
    border-bottom:3px solid #E6A23C !important;
}

.text-chart-title {
    color:#007bff;
    font-weight:bold;
    font-size:18px;
}

</style>